import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import { SetAlert } from "components/Alerts/actions";

import { ToasterContextProvider } from "./components/Workspace/Provider";

export function HublyToaster({ children }) {
  const dispatch = useDispatch();

  return (
    <ToasterContextProvider
      fireToaster={(alert) => {
        dispatch(SetAlert(alert));
      }}
    >
      {children}
    </ToasterContextProvider>
  );
}

HublyToaster.propTypes = {
  children: PropTypes.node,
};

HublyToaster.defaultProps = {
  children: null,
};

export default HublyToaster;
